const images = require.context("../images", true)
const audios = require.context("../audios", true)

const content = {
	imageContainerClass: "bg-extended pos-1",
	images: [
		{
			src: images("./page13.jpg"),
			class: "image-one",
			imgdiv: "imageCover",
		},
		{
			src: images("./keep_with_hen.gif"),
			class: "image-one img09",
			imgdiv: "imageCover",
		},
		{
			src: images("./7_bird_fly.gif"),
			class: "image-one bird_fly7",
			imgdiv: "imageCover",
		},
		{
			src: images("./3_bird_fly.gif"),
			class: "image-one bird_fly3",
			imgdiv: "imageCover",
		},
	],
	texts: [
		{
			textDivClass: "story-text page13Text text-center",
			textIndivData: [
				{
					textData: "कविले फुललाई कुखुरीको खोरमा राखे।",
					textClass: "m-0",
					timestamps: [{ start: 0 }, { start: 0.75 }, { start: 1.1 }, { start: 1.75 }, { start: 2.1 }],
				},
			],
		},
	],
	sounds: [
		{
			url: audios("./13.ogg"),
			delay: 500,
		},
		{
			url: audios("./sunset.ogg"),
			delay: 500,
			isBg: true,
			volume: 0.2,
		},
	],
}

export default content
